import { BehaviorSubject } from 'rxjs';
import { environment } from '@cde-fe-app/environments/environment';

export const isDestroyedOutputRefError = (error: unknown): boolean => {
  const message =
    typeof error === 'string'
      ? error
      : typeof error === 'object' && error != null && 'message' in error
        ? String((error as { message?: unknown }).message)
        : '';

  return message.includes('NG0953') && message.includes('OutputRef');
};

export const safeSubjectNext = <T>(subject: BehaviorSubject<T>, value: T, context: string) => {
  try {
    subject.next(value);
  } catch (error) {
    if (isDestroyedOutputRefError(error)) {
      console.warn(`Ignored ${context} emission because receiver was already destroyed.`, error);
      return;
    }

    throw error;
  }
};
export const bearerToken$ = new BehaviorSubject<string>('');
export const dealerLocatorRequestConfig = new BehaviorSubject<{
  country: string;
  language: string;
  noGeoCodedCountriesList: string[];
}>({
  country: 'de',
  language: 'en-gb',
  noGeoCodedCountriesList: environment.noGeoCodedCountriesList,
});
